const API_END_POINT = process.env.REACT_APP_API_END_POINT;

export default API_END_POINT;